<template>
  <div v-if="image" class="iorder-item-image">
    <base-image
      class="iorder-item-image__img"
      :desktop-url="image"
      :desktop-alt="altText"
      :custom-params="{ desktop: 500, tablet: 400, mobile: 715, mobileS: 430 }"
    />
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import type { MenuItemImageProps } from './types';
import BaseImage from '../../2_elements/BaseImage/BaseImage.vue';

const props = withDefaults(defineProps<MenuItemImageProps>(), {
  altText: 'Image',
});
</script>

<style lang="scss">
@import './scss/MenuItemImage.scss';
</style>
